import React, { Component } from 'react';
import { Table, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Landing from '../../views/common/Landing';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
// Duplicate import removed
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import Moment from 'react-moment';
import 'moment-timezone';
import topiccompletedIcon from '../../images/icons/topiccompleted_icon.png';
import recentTopicIcon from '../../images/icons/recenttopic_icon.png';
import gradeEarnedIcon from '../../images/icons/gradeEarned_icon.png';
import pointsEarnedBig from '../../images/icons/pointsEarnedBig_icon.png';
import pointsEarnedSmall from '../../images/icons/scardp_icon.png';
import recentLessonIcon from '../../images/icons/topic_lesson_icon.png';
import heymathIcon from '../../images/icons/hey_icon.png';
import reportProficienyIcon from '../../images/icons/report-proficiency.png';
import reportPracticeIcon from '../../images/icons/report-practice.png';
import '../../css/dashboard.css';

import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import PiechartComp from '../../views/scorecard/Piechart';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import $ from 'jquery';

const gradeArr = ["a","b","c"];

let topicList= [];


let defaultOption = topicList[0];

class Dashboard extends Landing{
	constructor() {
		super();
		this.state = {
		    // existing state fields...
		    // Report generation state
		    reportRequestId: null,
		    reportGenerating: false,
		    reportReady: false,
		    reportStatusMessage: '',
		    reportDownloadUrl: '',
		    topicsCompleted: 0,
		    topicsTotal: 0,
		    recentTestData: {},
		    selectedTopic: null,
		    selectedSubTopic: null,
		    gradeArr: [],
		    productArr: [],
		    comboNamesLoaded: false,
			overallPerformanceLoaded:false,
			recentTopicLoaded:false,
			pointsEarned:0,
			grade:this.rb("dash.not_available"),
			feedbackText:"",
			selectedProduct:"",
			noProducts:false,
			ModalShow:false,
			isTeacher:false,
			isStudent:false,
			schoolId:0
		};

		this.topicListRequestAllowed = true;

		this.selectedGradeOption = null;
		this.selectedProductOption = null;
		this.gradeProductMap = {};
		this.classDefnMap = {};
		this.topicDropdownChange = this.topicDropdownChange.bind(this);
		this.topicDescMap = {};
		this.topicTestMap = {};
		this.completedTopicCount = 0;
		this.gradeDefns = [];
		this.topicGradeDtls = {};
		//this.plpDashboard = 1; Unused 
		//this.testDashboard = 2; Unused
		//this.lessonDashboard = 3; NOT USED ANYMORE - PATHETIC Way of hardcoding
		this.totalTopicTimeSpent = 0;
		this.noLessonMode = false;
		this.gradeStore = null;
 		this.dashboardDropDownKey = "homeDropdown";//"dashDropdown";
 		this.preferredGrade = null;
 		this.preferredProduct = null;
		//this.pointsEarned = 0;
		this.subTopicClick = this.subTopicClick.bind(this);
		this.TopicClick = this.TopicClick.bind(this);
		this.productsAvailableToAccess = this.productsAvailableToAccess.bind(this);
		
		this.setChild(this,"DASHBOARD");
		
		this.hideLoginModal = this.hideLoginModal.bind(this);
		this.showPreviousAttempts = this.showPreviousAttempts.bind(this);
		this.showMoreAttempt = this.showMoreAttempt.bind(this);
		this.showLessAttempt = this.showLessAttempt.bind(this);
		//this.triggerPreviousAttempts = this.triggerPreviousAttempts.bind(this);

		this.attemptsArr = [1,2,3,4,5,6];
		this.attemptBoundry = 3;
		//
		this.genReportInit = this.genReportInit.bind(this);
		this.pollReportStatus = this.pollReportStatus.bind(this);
		this.downloadReportInit = this.downloadReportInit.bind(this);
		//
	}

	isLessonOnlyProduct(accessId){
		let lessonOnlyProds = window.lessonOnlyEntl || ["PLP|LESSON|VIEW","TCHR|LESSON|VIEW"];

		if(lessonOnlyProds && lessonOnlyProds.length > 0){
			return (lessonOnlyProds.indexOf(this.getUser().getAccessMap()[accessId]) > -1);
		}else{
			return false;
		}
	}
	
	componentWillUnmount(){
        if(this.pollTimeout){
            clearTimeout(this.pollTimeout);
        }
        // existing cleanup code if any
    }

	componentDidUpdate(prevProps, prevState) {
    	// No specific update logic needed currently
	}

	// Fetch session information to store schoolId, teacher, student flags
	fetchSessionInfo() {
		//Anandh lumos session check
	    const url = this.getUrlFor("LUMOS_SESSION_CHECK");
	    const me = this;
	    new HmAjax(url).get(
	        (resp) => {
	        	console.log(resp)
	        	//Check Anandh for session.action
	            if (resp && resp.sessionValid) {
	                const { user } = resp;
	                if (user && user.schoolId) {
	                    //
	                    //localStorage.setItem('schoolId', user.schoolId);
	                    //
	                    me.setState({schoolId:user.schoolId});
	                    if(user.role == "TCHR" && (user.schoolId == "352" || user.schoolId == "297" || user.schoolId == "55653"))
	                    {
	                		//
	                		me.setState({isTeacher:true});
	                    }else{
	                		//
	                		me.setState({isTeacher:false});
	                    }
	                    //
	                }
	                //
		            me.getReportStatus();
		            //
	            }
	           //
	        },
	        (err) => {
	            console.error('Session check failed', err);
	        }
	    );
	}


	componentDidMount(){
        super.componentDidMount();

        if(this.productsAvailableToAccess()){
            this.setPreferredDd();
            this.getGradeList();
        }else{
            setTimeout(function(){   			
              		$(".page-content nav.side-navbar ul li").addClass("noclicks");
            },1000)
            		
            this.setState({noProducts:true});
        }
        this.fireMobileToast();
        // Fetch session info to capture schoolId, teacher, student flags
        this.fetchSessionInfo();
        //this.getReportStatus();
        //

        //this.populateSubTopics(defaultOption);
    }
	//
	componentDidUpdate(prevProps, prevState) {
	    //
	}

	productsAvailableToAccess(){
		var user = this.getUser();
		if(user != null){
			var permissions = user.getEntlHistory();
			if(permissions != null && Object.keys(permissions).length > 0){
				for(var i in permissions){
					if(permissions[i] != null){
						var totalLevel = permissions[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0){
							return true;
						}
					}
				}
			}
		}

		return false;
	}
	setPreferredDd(){
		try{
			var gradeStore = null;
			var prefStr = this.getAttribute(this.dashboardDropDownKey);
			if(prefStr)
				gradeStore = JSON.parse(prefStr);
			
			console.log("dashboard gradeStore::",gradeStore);
			if(typeof gradeStore === "object"){
				this.preferredGrade = gradeStore["grd"];
				this.preferredProduct = gradeStore["prod"];;
			}
		}catch(e){}
	}
	//For feedback text
	getFeedbackText(){
		return this.state.feedbackText;
	}

	calculateGradeForTopics(topicTestMap){
		for(var i in topicTestMap){
			if(topicTestMap[i].status === "COMPLETED"){
				var userPoints = topicTestMap[i].userPoints || 0;
				var topicPoints = topicTestMap[i].topicPoints || 0; 
				if(topicPoints > 0){
					var percentage = Math.round((userPoints * 100) / topicPoints );
					
					topicTestMap[i].grade = this.calculateGrade(percentage);
					topicTestMap[i].feedback =  this.processFeedbackTextByGrade(topicTestMap[i].grade, percentage);
				}
			}else if(topicTestMap[i].status === "IN_PROGRESS"){
				topicTestMap[i].feedback = this.rb("dash.label.topic.feedback-inprogress");
			}else{
				topicTestMap[i].feedback = this.rb("dash.label.topic.feedback-unattempted");
			}
		}
	}

	calculateGrade(percentage){
		if(!isNaN(percentage) && this.gradeDefns && this.gradeDefns.length > 0){
			for(var i =0; i < this.gradeDefns.length; i ++){
				if( percentage >= this.gradeDefns[i].minPercent && percentage <= this.gradeDefns[i].maxPercent){
					return this.gradeDefns[i].grade;
				}
			}
		}

		return this.rb("dash.not_available");
	}

	processFeedbackTextByGrade(grade, percentage){
		if(percentage === 100){
			return this.rb("dash.label.topic.grade-full-A+");
		}else if(grade && grade.length > 0){
			return this.noLessonMode ? this.rb("dash.label.topic.nolesson-grade-"+grade) : this.rb("dash.label.topic.grade-"+grade);
		}
	}

	getOriginalFeedBackText(gradeDtls) {		
		if (gradeDtls.oldPercent === 100) {
			return this.rb("scorecard.test.grade-full-A+");
		} else {
			return this.noLessonMode ? this.rb("scorecard.test.nolesson-grade-" + ((gradeDtls.oldGrade && gradeDtls.oldGrade.length > 0) ? gradeDtls.oldGrade : "")) :  this.rb("scorecard.test.grade-" + ((gradeDtls.oldGrade && gradeDtls.oldGrade.length > 0) ? gradeDtls.oldGrade : ""));
		}
	}

	getUpdatedFeedBackText(gradeDtls) {
		if (gradeDtls.newPercent === 100) {
			return this.rb("scorecard.practice.grade-full");
		} else if (gradeDtls.gradeChanged) {
			return this.rb("scorecard.practice.grade-change").replace("{1}", gradeDtls.oldGrade).replace("{2}", gradeDtls.newGrade);
		} else if (gradeDtls.percentChanged) {
			return this.rb("scorecard.practice.grade-nochange").replace("{1}", gradeDtls.oldPoints).replace("{2}", gradeDtls.newPoints);
		}  else {
			return this.rb("scorecard.practice.point-nochange");
		}
	}

	processFeedbackTextForSubTopic(subTopic){
		if(subTopic){
			if(this.topicGradeDtls && subTopic.status){
				try{
					var gradeDtls = (this.topicGradeDtls[subTopic.topicId] && this.topicGradeDtls[subTopic.topicId][subTopic.subTopicId] ) ? this.topicGradeDtls[subTopic.topicId][subTopic.subTopicId] : null;
					var subTopicPercent = 0;
					var subTopicGrade = "";

					// Both revision and practice, if available - completed
					if(subTopic.status === "COMPLETED" && gradeDtls !== null){
						if(subTopic.practiceStatus === "COMPLETED"){
							subTopic.feedback = this.getUpdatedFeedBackText(gradeDtls);
						}else{
							subTopic.feedback = this.getOriginalFeedBackText(gradeDtls);
						}
					}else if(subTopic.status === "IN_PROGRESS"){
					//Revision only completed, if completed
					if(subTopic.testStatus === "COMPLETED" && gradeDtls !== null){
						subTopic.feedback = this.getOriginalFeedBackText(gradeDtls);
					}else{
						subTopic.feedback = this.rb("dash.label.subtopic.feedback-inprogress");	
					}
				}else if(subTopic.status === "NEW"){
						//Just started
						subTopic.feedback = this.rb("dash.label.subtopic.feedback-inprogress");
					}else{
						subTopic.feedback = this.rb("dash.label.subtopic.feedback-unattempted");
					}

				}catch(e){
					console.error(e);
				}
			}else{
				subTopic.feedback = this.rb("dash.label.subtopic.feedback-unattempted");
			}
		}
		
		return subTopic;
	}

	processSubTopic(subTopic){
		var returnObj = {};
		var testScore = 0;
		var userScore = 0;
		var testStatus = "";
		var practiceStatus = "";
		var status = "";
		var grade = "";
		var subTopicPoints = 0;
		var userPoints = 0;
		var totalTimeSpent = 0;

		try{
			if(subTopic){
				if(subTopic.diagnosticTests){
					for(var i in subTopic.diagnosticTests){
						userScore += (!isNaN(subTopic.diagnosticTests[i].userScore)) ? subTopic.diagnosticTests[i].userScore : 0;
						testScore += (!isNaN(subTopic.diagnosticTests[i].score)) ? subTopic.diagnosticTests[i].score : 0;

						testStatus = subTopic.diagnosticTests[i].status;
					}
				}

				if(subTopic.customTests){
					for(var i in subTopic.customTests){
						userScore += (!isNaN(subTopic.customTests[i].userScore)) ? subTopic.customTests[i].userScore : 0;
						testScore += (!isNaN(subTopic.customTests[i].score)) ? subTopic.customTests[i].score : 0;

						practiceStatus = subTopic.customTests[i].status;
					}
					
				}

				subTopicPoints = !isNaN(subTopic.subTopicPoints) ? subTopic.subTopicPoints : 0;
				userPoints = !isNaN(subTopic.userPoints) ? subTopic.userPoints : 0;

				grade = subTopic.grade;
				status = subTopic.status;
				returnObj["topicId"] = subTopic.topicId || 0;
				returnObj["subTopicId"] = subTopic.subTopicId || 0;
				
				if(subTopic.lessons){
					for(var obj in subTopic.lessons){
						totalTimeSpent += subTopic.lessons[obj].timeSpent;
					}
				}
			}
		}catch(e){

		}
		returnObj["testScore"] = testScore;
		returnObj["userScore"] =  userScore;
		returnObj["status"] = status;
		returnObj["practiceStatus"] = practiceStatus;
		returnObj["testStatus"] =  testStatus;
		returnObj["grade"] = grade;
		returnObj["subTopicPoints"] = subTopicPoints;
		returnObj["userPoints"] = userPoints;
		returnObj["totalTimeSpent"] = totalTimeSpent;

		//process feedback text for SubTopic
		this.processFeedbackTextForSubTopic(returnObj);
		
		return returnObj;
	}
	TopicClick(event){
		//console.log(event.currentTarget);
		$(".DashboardComponent .subtopicCard").removeClass("selected");
		$(event.currentTarget).addClass("selected");
		let grade = event.currentTarget.dataset.grade;
		var subTopicId = event.currentTarget.dataset.subtopicid;
		if(!grade){
			grade = this.rb("dash.not_available");
		}


		this.setState({pointsEarned:event.currentTarget.dataset.userpoints,grade:grade,feedbackText:event.currentTarget.dataset.feedback,selectedSubTopic:null});
		
		
		var trackObj = {
			"item_id": subTopicId,
			"item_type": this.getTracker().enums.selectedItemType.topic,
			"source": this.getTracker().enums.selectedItemSource.dashboard
		}

		this.initiateTrack("item_selected",trackObj);
	}
	subTopicClick(event){
		//console.log(event.currentTarget);
		$(".DashboardComponent .subtopicCard").removeClass("selected");
		$(event.currentTarget).addClass("selected");
		let grade = event.currentTarget.dataset.grade;
		var subTopicId = event.currentTarget.dataset.subtopicid;
		if(!grade){
			grade = this.rb("dash.not_available");
		}


		this.setState({pointsEarned:event.currentTarget.dataset.userpoints,grade:grade,feedbackText:event.currentTarget.dataset.feedback,selectedSubTopic:this.state.selectedTopic.subTopics[subTopicId]});
		
		
		var trackObj = {
			"item_id": subTopicId,
			"item_type": this.getTracker().enums.selectedItemType.subtopic,
			"source": this.getTracker().enums.selectedItemSource.dashboard
		}

		this.initiateTrack("item_selected",trackObj);
	}
	genReportInit(){
		//
		//Retrive 
    	const level = localStorage.getItem('storedClassLevel') || 9999; // fallback
        //
        // Retrieve user info
        const userStore = new UserStore();
        //const schoolId = userStore.getSchoolId();
        const schoolId = this.state.schoolId;
        const userLoginId = userStore.getLoginId();

        this.setState({
            reportGenerating: true,
            reportStatusMessage: "Requesting report generation..."
        });

        const payload = { level, schoolId, userLoginId };
        let me = this;
        new HmAjax(this.getUrlFor("REPORT_GENERATE"), payload).post(
                (resp) => {
                    const requestId = resp.reqId || resp.requestId;
                    // No need to store requestId in localStorage now
                    me.setState({ reportRequestId: requestId });
                    me.pollReportStatus(requestId);
                },
                (err) => {
                    console.error(err);
                    me.setState({
                        reportGenerating: false,
                        reportStatusMessage: "Failed to start report generation."
                    });
                }
            );
    }

    pollReportStatus(requestId){
    	let me = this;
		new HmAjax(`${me.getUrlFor("REPORT_STATUS")}/${requestId}`).get(
			(resp) => {
				const status = resp.status ? resp.status.toUpperCase() : "";
				if (status === "COMPLETED") {
					const fileName = resp.fileName || resp.file;
                        const downloadUrl = `${me.getUrlFor("REPORT_DOWNLOAD")}/${fileName}`;
                        // Clear stored request ID upon completion
                        localStorage.removeItem('reportRequestId');
                        me.setState({
                            reportGenerating: false,
                            reportReady: true,
                            reportDownloadUrl: downloadUrl,
                            reportStatusMessage: "Report ready for download."
                        });
				} else if (status === "FAILED") {
					me.setState({
						reportGenerating: false,
						reportStatusMessage: "Report generation failed."
					});
				} else if (status === "IN_PROGRESS") {
					me.setState({ reportStatusMessage: "Report in progress..." });
					me.pollTimeout = setTimeout(() => me.pollReportStatus(requestId), 5000);
				} else {
					me.setState({
						reportGenerating: false,
						reportStatusMessage: `Report status: ${resp.status || "unknown"}`
					});
				}
			},
            (err) => {
                console.error(err);
                 // Clear stored request ID on error
                    localStorage.removeItem('reportRequestId');
                    me.setState({
                    reportGenerating: false,
                    reportStatusMessage: "Error checking report status."
                });
            }
        );
    }

    // Check initial report status when page loads (POST, no requestId stored)
    getReportStatus() {
    	//
    	//Retrive 
    	const level = localStorage.getItem('storedClassLevel') || 9999; // fallback
    	//
    	// Retrieve user info
        const userStore = new UserStore();
        //const schoolId = userStore.getSchoolId();
        const schoolId = this.state.schoolId;
        const userLoginId = userStore.getLoginId();

        let me = this;
        const payload = { level, schoolId, userLoginId };
        // POST to the status endpoint directly
        new HmAjax(this.getUrlFor("REPORT_STATUS_INITIAL"), payload).post(
            (resp) => {
                const status = resp.status ? resp.status.toUpperCase() : "";
                if (status === "IN_PROGRESS") {
                    // Continue polling for progress using the requestId from response if provided
                    const requestId = resp.reqId || resp.requestId;
                    if (requestId) {
                        me.setState({ reportRequestId: requestId, reportGenerating: true, reportStatusMessage: "Report in progress..." });
                        me.pollReportStatus(requestId);
                    } else {
                        me.setState({ reportGenerating: true, reportStatusMessage: "Report in progress..." });
                    }
                } else if (status === "COMPLETED") {
                    // Report ready
                    const fileName = resp.fileName || resp.file;
                    const downloadUrl = `${me.getUrlFor("REPORT_DOWNLOAD")}/${fileName}`;
                    me.setState({
                        reportGenerating: false,
                        reportReady: true,
                        reportDownloadUrl: downloadUrl,
                        reportStatusMessage: "Report ready for download."
                    });
                } else {
                    // No ongoing report
                    me.setState({ reportGenerating: false, reportStatusMessage: `Report status: ${resp.status || "none"}` });
                }
            },
            (err) => {
                console.error(err);
                me.setState({ reportGenerating: false, reportStatusMessage: "Error checking initial report status." });
            }
        );
    }

    downloadReportInit(){
        const { reportDownloadUrl, reportRequestId } = this.state;
        if(!reportDownloadUrl) return;
        // Build filename: className_schoolId.xlsx
        const userStore = new UserStore();
        const className = this.defaultOption ? this.defaultOption.label : "primary7";
        //const schoolId = userStore.getSchoolId();
        const schoolId = this.state.schoolId;
        const filename = `${className}_${schoolId}.xlsx`;
        const a = document.createElement('a');
        a.href = reportDownloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }	

    populateSubTopics(){
		//console.log("populateSubTopics");
		if(this.state.selectedTopic && this.state.selectedTopic.subTopics){
			var me= this;
			var timeSpent = 0;
			//console.log(this.state.selectedTopic)
			var subTopicsArr = Object.values(this.state.selectedTopic.subTopics);
			this.totalTopicTimeSpent = 0;
			
			
			//this.setState({feedbackText: this.topicTestMap[this.defaultOption.value].feedback || "", grade: this.topicTestMap[this.defaultOption.value].grade || this.rb("dash.not_available"),selectedTopic:this.topicTestMap[selectedOption.value],selectedSubTopic:null, pointsEarned:(this.topicTestMap && this.topicTestMap[selectedOption.value] && this.topicTestMap[selectedOption.value].userPoints && !isNaN(this.topicTestMap[selectedOption.value].userPoints)) ? this.topicTestMap[selectedOption.value].userPoints : 0});
			var topicstatus = this.topicTestMap[this.defaultOption.value].status;
			var statusclass = "un_attempted";
			if(topicstatus.toLowerCase() == "completed"){
				statusclass = "completed";
			}else if(topicstatus.toLowerCase() == "in_progress"){
				statusclass = "in_progress";
			}
			//console.log("subtopic satus=="+subtopic.status);
			var mygrade = this.topicTestMap[this.defaultOption.value].grade || this.rb("dash.not_available");
			let cssgrade = mygrade.toLowerCase().split("+").join("plus");
			if(this.isLessonOnlyProduct(this.state.selectedProduct)){
				cssgrade = statusclass;
			}
			
			var userPoints = this.topicTestMap[this.defaultOption.value].userPoints;
			var feedback = this.topicTestMap[this.defaultOption.value].feedback;
			var topicId = this.topicTestMap[this.defaultOption.value].topicId;
						
			return(
				<div className="subtopicContainer clearfix">
				
				
				<div className={"card subtopicCard selected float-left grade_"+cssgrade+" "+statusclass} data-userpoints={userPoints} data-grade={mygrade} data-feedback={feedback} data-subtopicid={topicId} onClick={this.TopicClick} >
					<div className="card-body">						   
							<p className="card-text subcardText">{this.rb("dash.overall.topic")}</p>								
					</div>
				</div>
							
				{subTopicsArr.map((subtopic,index) =>	
					{
						subtopic["topicId"] = this.state.selectedTopic.topicId;
						var processedSubTopic = me.processSubTopic(subtopic)
						
						var userEarnedPoints = !isNaN(processedSubTopic.userPoints) ? processedSubTopic.userPoints : 0;
						
						var mygrade = processedSubTopic.grade || "";
						var subTopicMarks = processedSubTopic.userScore + " / " +processedSubTopic.testScore;
						var statusclass = "un_attempted";
						if(subtopic.status.toLowerCase() == "completed"){
							statusclass = "completed";
						}else if(subtopic.status.toLowerCase() == "in_progress"){
							statusclass = "in_progress";
						}
						//console.log("subtopic satus=="+subtopic.status);
						this.totalTopicTimeSpent += processedSubTopic.totalTimeSpent;						
						let cssgrade = mygrade.toLowerCase().split("+").join("plus");
						if(me.isLessonOnlyProduct(me.state.selectedProduct)){
							cssgrade = statusclass;
						}
						return(
							<div className={"card subtopicCard float-left grade_"+cssgrade+" "+statusclass} key={index} data-userpoints={processedSubTopic.userPoints} data-grade={processedSubTopic.grade} data-feedback={processedSubTopic.feedback} data-subtopicid={processedSubTopic.subTopicId} onClick={this.subTopicClick} >
							<div className="card-body">						   
							<p className="card-text subcardText">{subtopic.subTopicName}</p>	
							{(() => {
								if(!me.isLessonOnlyProduct(me.state.selectedProduct)){
									if(subtopic.status.toLowerCase() === "un_attempted") {
										return <div className="text-center gradeinfo notattempted">{this.rb("dash.notattempted")}</div>;
									}/*else if(subtopic.status.toLowerCase() === "in_progress") {
										return <div className="text-center gradeinfo notattempted">{this.rb("dash.inprogress")}</div>;
									}*/else{
										return <div className="text-center gradeinfo">{mygrade.toUpperCase()}</div>;
									}
								}else{
									if(subtopic.status.toLowerCase() === "un_attempted") {
										return <div className="text-center gradeinfo notattempted">{this.rb("dash.notattempted")}</div>;
									}/*else if(subtopic.status.toLowerCase() === "in_progress") {
										return <div className="text-center gradeinfo notattempted">{this.rb("dash.inprogress")}</div>;
									}*/
								}
								
							})()}
							</div>
							</div>
							);										 				
						}
						)}
						</div>
						)
					}
				}
				getTopicCompletedPercentage(){					
					//console.log(this.completedTopicCount,topicList.length);
					var percentComplete = 0 ;
					percentComplete = Math.round((this.completedTopicCount / topicList.length) * 100);
					return percentComplete;
				}
				getGradeDisplay(){
					if(this.state.grade == this.rb("dash.not_available")){
						return <div className="greyColor fsp8rem">{this.state.grade}</div>;
					}else{
						let cssgrade = this.state.grade.toLowerCase().split("+").join("plus");
						if(this.isLessonOnlyProduct(this.state.selectedProduct)){
							cssgrade = "";
						}
						
						return <div className={"reward "+cssgrade}>{this.state.grade}</div>;
					}

				}
				getTopicsCompletedContent(){
					if(this.state.overallPerformanceLoaded){
						return(
							<div className="row flexcenter justifycenter">
							<div className="col-12 col-sm-4 flexcenter">
							<img className="widgetIcon" src={topiccompletedIcon} />
							</div>
							<div className="col-12 col-sm-4 text-right piechartparent">
							{this.piechartFn(this.completedTopicCount,topicList.length)}							                		
							</div>
							</div>
							);
					}else{
						return(<div>{this.showLoader()}</div>);
					}

				}
				getTopicsCompletedTitle(){
					if(this.isLessonOnlyProduct(this.state.selectedProduct)){
						return (this.rb("dash.topics_watched"));
					}else{
						return (this.rb("dash.topics_completed"));
					}
				}
				getRecentAttemptTitle(){
					if(this.isLessonOnlyProduct(this.state.selectedProduct)){
						return (this.rb("dash.recently.watched"));
					}else{
						return (this.rb("dash.recently.attempted.topic"));
					}
				}
				getOverallTitle(){
					if(this.isLessonOnlyProduct(this.state.selectedProduct)){
						return (this.rb("dash.overall.summary"));
					}else{
						return (this.rb("dash.overall.performance"));
					}
				}

				getRecentAttemptedTopicContent(){
					var me = this;
					if(this.state.recentTopicLoaded){

						if(Object.keys(this.state.recentTestData).length > 0){
							var firstAccessDate = !isNaN(this.state.recentTestData.startTime) ? (this.state.recentTestData.startTime) : null;
							var testSubmitDate = !isNaN(this.state.recentTestData.endTime) ? (this.state.recentTestData.endTime) : null;
							var Accessedon = !isNaN(this.state.recentTestData.inTime) ? (this.state.recentTestData.inTime) : " ";
							var testRecentAccessDate = !isNaN(this.state.recentTestData.trackOpenTime) ? (this.state.recentTestData.trackOpenTime) : null;
							var recentTopicTitle = this.state.recentTestData.title;
							var recentTopicSubmittedon = testSubmitDate || testRecentAccessDate || firstAccessDate;
							var recentTopicStatus = (this.state.recentTestData.status === "NEW") ? me.rb("IN_PROGRESS") : me.rb(this.state.recentTestData.status);
							var recentTopicPoints = this.state.recentTestData.totalPoints;
							var recentTopicUserPoints = this.state.recentTestData.userPoints;
							var recentTopicName = this.state.recentTestData.topicName || "";
							var recentSubTopicName = this.state.recentTestData.subTopicName || "";
							var activityMode = (this.state.recentTestData.isActualTest === "true") ? "scorecard.revision_test" : "scorecard.custom_practice";
							var recentSubmittedName = this.rb("dash.submitted_on");

							if(this.state.recentTestData.status == "IN_PROGRESS"){
								recentSubmittedName = this.rb("dash.accessed_on");
							}
							else if(this.state.recentTestData.status == "NEW"){
								recentSubmittedName = this.rb("dash.accessed_on");
							}
								//console.log("dash Recent data : ", this.state.recentTestData);
								if(this.isLessonOnlyProduct(this.state.selectedProduct)){
									return(
										<div className="row">
										<div className="col-12 col-sm-3 recentIconContainer lessonRecentBox">
										<img className="widgetIcon" src={recentLessonIcon} />
										</div>
										<div className="col-12 col-sm-9 norightpadding headerTxt clearfix">
										<div className="row lessonRecentBox">
										<div className="recentTopicName col-12 col-sm-8 nopadding">
										<div className="greyColor">{recentTopicName}</div>
										<div className="pt-10">{recentSubTopicName}</div>
										</div>																				

										<div className="infoTxt col-12 col-sm-4 nopadding lessonAccessedTxt">
										<span className="borderBottom clearfix">{this.rb("dash.watched_on")}</span>
										<div className="greyColor"><Moment unix format="DD/MM/YYYY">{this.getTimeUtil().setServerTime(Accessedon).getServerTime()}</Moment></div>
										<div className="greyColor"><Moment unix format="hh:mm:ss A">{this.getTimeUtil().setServerTime(Accessedon).getServerTime()}</Moment></div>
										</div>
										</div>			
										</div>
										</div>

										);
								}else{
									return(
										<div className="row">
										<div className="col-12 col-sm-3 recentIconContainer">
										<img className="widgetIcon" src={recentTopicIcon} />
										</div>
										<div className="col-12 col-sm-9 norightpadding headerTxt clearfix">
										<div className="recentTopicName">
										<div className="greyColor">{recentTopicName}</div>
										<div className="pt-10">{recentSubTopicName} - {this.rb(activityMode)}</div>
										</div>
										<div className="row">									

										<div className="infoTxt row col-12 recentAttemptInfo">
										<div className="col-12 col-sm-4 nopadding">
										<span className="borderBottom clearfix">{recentSubmittedName}</span>
										<div className="greyColor"><Moment unix format="DD/MM/YYYY">{this.getTimeUtil().setServerTime(recentTopicSubmittedon).getServerTime()}</Moment></div>
										<div className="greyColor"><Moment unix format="hh:mm:ss A">{this.getTimeUtil().setServerTime(recentTopicSubmittedon).getServerTime()}</Moment></div>
										</div>

										<div className="col-12 col-sm-4 nopadding plp4">
										<span className="borderBottom">{this.rb("dash.status")}</span>
										<div className="greyColor">{recentTopicStatus}</div>
										</div> 

										<div className="col-12 col-sm-4 nopadding">
										<span className="borderBottom">{this.rb("dash.points_earned")}</span>
										<div className="points"><i className="material-icons">flash_on</i> {recentTopicUserPoints}</div> 
										</div> 

										</div>
										</div>

										</div>
										</div>

										);
								}
							}else{
								return(
									<div className="row pt-45">
									<div className="col-12 col-sm-3 pb-20">
									<img className="widgetIcon" src={recentTopicIcon} />
									</div>
									<div className="col-12 col-sm-9 nodatamsg">
										You have not started any topic
									</div>

									</div>
									);
							}
						}else{
							return(<div>{this.showLoader()}</div>);
						}

					}
					hhmmss(secs) {
						var minutes = Math.floor(secs / 60);
						secs = secs%60;
						var hours = Math.floor(minutes/60)
						minutes = minutes%60;
						return this.pad(hours)+":"+this.pad(minutes)+":"+this.pad(secs);
					}
					pad(num) {
						return ("0"+num).slice(-2);
					}
					getLessonTable(){
						//console.log("lessontable...");
						/*return(
							{this.state.selectedSubTopic.lessons.map((lesson, index) => {
								return (<tr key={index}>
								<td>{lesson.lessonName}</td>
								<td>{lesson.timeSpent}</td>
								</tr>)
							})}
							);*/
							return (<tr>
								<td>"lessonName"</td>
								<td>"timeSpent"</td>
								</tr>)
						}

						renderOverallSubtopicInfo(){
							if(this.isLessonOnlyProduct(this.state.selectedProduct)){							
								try{
									return(
										<div className="col-12 col-sm-12 col-lg-6 clearfix nopadding">
										<div className="col-12 nopadding bottomPadding">										
										{(() => {
											var totaltimespent = this.hhmmss(this.totalTopicTimeSpent);
											if(this.state.selectedSubTopic == null){
												return (
													<div>
													<div className="bottomBorder">{this.rb("dash.totaltimespenttopic")}</div>
													<div className="topicTimeSpent text-center">{totaltimespent}</div>
													</div>
													)
												}else{		

													return (
													<div>
													<div className="bottomBorder">Subtopic - {this.state.selectedSubTopic.subTopicName}</div>
													<div className="lessonTable">
													<Table className="result1">
													<thead>
													<tr className="resulthead">
													<th>{this.rb("dash.lessonname")}</th>
													<th>{this.rb("dash.timespent")}</th>
													</tr>
													</thead>

													<tbody>

													{Object.keys(this.state.selectedSubTopic.lessons).map((lesson, index) => (
														<tr key={index}>
														<td>{this.state.selectedSubTopic.lessons[lesson].lessonName}</td>
														<td>{this.hhmmss(this.state.selectedSubTopic.lessons[lesson].timeSpent)}</td>
														</tr>
														))}
														</tbody>
														</Table>
														</div>
														</div>
														);							    		       
													}
												})()}	
												</div>

												</div>
												);
											}catch(e){}
										}else{
											let me = this;
											return(
											<div className="col-12 col-sm-12 col-lg-6 clearfix nopadding">
											
											{(() => {	
												if(me.state.selectedSubTopic && me.state.selectedSubTopic != null){
													if(me.state.selectedSubTopic.archivedTestDetails && me.state.selectedSubTopic.archivedTestDetails!=null){
														return(
															<div className="row bottomBorder mb20 overallRHS">
																<div className="col-12 col-sm-8">{this.rb("dash.subtopic")} - {this.state.selectedSubTopic.subTopicName}</div>
																<div className="col-12 col-sm-4 text-right norightpadding">
																	<div className="btn btn-primary btnAttempts" onClick={this.triggerPreviousAttempts.bind(this,Object.values(me.state.selectedSubTopic.archivedTestDetails))}>{this.rb("dash.previousattempts")}</div>
																</div>
															</div>
														)
													}
													else{
														return(
															<div className="row bottomBorder mb20 overallRHS">
																<div className="col-12 col-sm-8">{this.rb("dash.subtopic")} - {this.state.selectedSubTopic.subTopicName}</div>
															</div>
														)
													}
												}											
												
											})()}											

											<div className="row col-12 nopadding bottomBorder bottomPadding">
											<div className="col-6 row clearfix nopadding rightBorder flexcenter">
											<div className="float-left rightPadding">
											<img className="gradeEarnedIcon" src={gradeEarnedIcon} />
											</div>
											<div className="float-left">
											<div className="headerTxt clearfix">
											<div>{this.rb("dash.grade_earned")}</div>
											{this.getGradeDisplay()}									            				
											</div>             		
											</div>
											</div>
											<div className="col-6 row clearfix nopadding flexcenter">
											<div className="float-left rightPadding">
											<img className="pointsEarnedBig" src={pointsEarnedBig} />
											</div>
											<div className="float-left">
											<div className="headerTxt clearfix">
											<div>{this.rb("dash.points_earned")}</div>
											<div className="yellowColor bigPoints">{this.state.pointsEarned}</div>              				
											</div>             		
											</div>
											</div>
											</div>

											<div className="row col-12 statusMsgrow plpmsggrow">
											<div className="col-12 col-sm-3 pb-20">
											<img src={heymathIcon} />
											</div>
											<div className="col-12 col-sm-9 text-center feedbackTxtDiv">
											<div>{this.getFeedbackText()}</div>
											</div>
											</div>

											</div>
											);
										}
									}
									getOverallPerformanceContent(){
										if(this.state.overallPerformanceLoaded){
											return(
											<div className="row clearfix">
											<div className="col-12 col-sm-12 col-lg-6 topicDropdown">
											{this.downloadReportLoader()}
											<br></br>
											<Dropdown options={topicList} onChange={this.topicDropdownChange} value={this.defaultOption} placeholder="Select an option" />
											{this.populateSubTopics()}
											</div>
											{this.renderOverallSubtopicInfo()}
											</div>
											);
										}else{
											return(<div>{this.showLoader()}</div>);
										}

									}
									downloadReportLoader()
									{
										return (
									
								    	   <div className="genReportContainer">
								                {!this.state.reportGenerating && this.state.isTeacher && (
												    <button id="generateBtn" className="btn btn-primary" onClick={this.genReportInit}>
												        <i className="fa-solid fa-bar-chart"></i> Generate Report
												    </button>
												)}
								                {this.state.reportGenerating && this.state.isTeacher && (
								                <button className="btn btn-primary" disabled>
								                    Generating...
								                </button>
								                )}
								                {this.state.reportReady  && this.state.isTeacher &&(
								                <button id="downloadBtn" className="btn btn-success" onClick={this.downloadReportInit}>
								                    <i className="fa-solid fa-download"></i> Download Report
								                </button>
								                )}
								                {this.state.isTeacher && (
								                <div id="status">{this.state.reportStatusMessage}</div>
								                )}
								            </div>
										       
										)
									}
									downloadReportLoader2()
									{
										return (
											<div className="row clearfix">
										    	   <div className="col-12 col-sm-12 col-lg-6 genReportContainer">
										                {!this.state.reportReady && !this.state.reportGenerating && (
										                <button id="generateBtn" className="btn btn-primary" onClick={this.genReportInit}>
										                    <i className="fa-solid fa-bar-chart"></i> Generate Report
										                </button>
										                )}
										                {this.state.reportGenerating && (
										                <button className="btn btn-primary" disabled>
										                    Generating...
										                </button>
										                )}
										                {this.state.reportReady && (
										                <button id="downloadBtn" className="btn btn-success" onClick={this.downloadReportInit}>
										                    <i className="fa-solid fa-download"></i> Download Report
										                </button>
										                )}
										                <div id="status">{this.state.reportStatusMessage}</div>
										            </div>
										        </div>
										)
									}
									topicDropdownChange(selectedOption){		
										this.defaultOption = selectedOption;
										this.totalTopicTimeSpent = 0;
										this.setState({feedbackText: this.topicTestMap[this.defaultOption.value].feedback || "", grade: this.topicTestMap[this.defaultOption.value].grade || this.rb("dash.not_available"),selectedTopic:this.topicTestMap[selectedOption.value],selectedSubTopic:null, pointsEarned:(this.topicTestMap && this.topicTestMap[selectedOption.value] && this.topicTestMap[selectedOption.value].userPoints && !isNaN(this.topicTestMap[selectedOption.value].userPoints)) ? this.topicTestMap[selectedOption.value].userPoints : 0});
						//this.setState({selectedTopic:this.topicTestMap[selectedOption.value]}); // using same state above
										try{
											var trackObj = {
												"item_id": this.defaultOption.value,
												"item_type": this.getTracker().enums.selectedItemType.topic,
												"source": this.getTracker().enums.selectedItemSource.dashboard
											}
									
											this.initiateTrack("item_selected",trackObj);
										}catch(e){}
											
					}
					getProductList(){
						var preselectIndex = 0;
						var gradeProductMap = this.gradeProductMap;

						var permissions = gradeProductMap[this.selectedGradeOption.value];
						var accessMap = this.getUser().getAccessMap();

						if(permissions.length > 0){
							var productArr = [];
							for(var i=0;i<permissions.length;i++){
								var classCode = this.classDefnMap[this.selectedGradeOption.value].classCode;
								var board = this.classDefnMap[this.selectedGradeOption.value].board
								var label = this.rb(accessMap[permissions[i]] + "-" + classCode + "-" + board  ) || this.rb("label-"+permissions[i] + "-" + classCode + "-" + board);
								if((label === accessMap[permissions[i]] + "-" + classCode + "-" + board) || (label === "label-"+permissions[i] + "-" + classCode + "-" + board)){
									label = this.rb(accessMap[permissions[i]]+"-menu") || this.rb("label-"+permissions[i]);
								}
				
								productArr.push({"label":label,"value":permissions[i]});
								console.log("product::",permissions[i],this.preferredProduct);
								if(permissions[i] == parseInt(this.preferredProduct)){ console.log("selectedindex::"+i);
								preselectIndex = i;
							}
						}			
						this.selectedProductOption = productArr[preselectIndex];
						this.setState({productArr:productArr});	
						this.getTopics();							
					}else{
							//this.showAlert("",this.rb("home.not_entitled"));
						}

					}
					getGradeList(){		
						var me = this;

						var callBack = function(response){
							console.log("response:::",response);
							var grades = response.classId;
							var products = response.accessId;
							
							var classDefnMap = response.classDefn;
							me.gradeProductMap =  response.gradeProdMap;
							me.classDefnMap = classDefnMap;

							var gradeArr =[];
							var preselectIndex = 0;
							console.log("grades::",grades);
							if(grades !== null && grades.length > 0){
								for(var i=0;i<grades.length;i++){
									if(grades[i] > 0){
										try{
											var dropDownLabel = me.rb(classDefnMap[grades[i]].className);
											
											if(classDefnMap[grades[i]] && classDefnMap[grades[i]].gradeId){
												/**
												* IMPORTANT: Replace classId with gradeId when available.
												* This is for grouped classes
												*/
												
												//if(groupedGradesList.indexOf(classDefnMap[grades[i]].gradeId) === -1){
													let gradeDisplayName = me.rb(classDefnMap[grades[i]].gradeDisplayName);
													//gradeArr.push({"label":gradeDisplayName,"value":classDefnMap[grades[i]].gradeId});	
													classDefnMap[grades[i]]["label"] = gradeDisplayName;
													classDefnMap[grades[i]]["value"] = grades[i];
													gradeArr.push(classDefnMap[grades[i]]);
													//gradeArr.push({"label":gradeDisplayName,"value":grades[i],"gradeId":classDefnMap[grades[i]].gradeId,"classId":grades[i]});	
												//	groupedGradesList.push(classDefnMap[grades[i]].gradeId);
												//}
											}else{
												classDefnMap[grades[i]]["label"] = dropDownLabel;
												classDefnMap[grades[i]]["value"] = grades[i];
												gradeArr.push(classDefnMap[grades[i]]);
												//gradeArr.push({"label":dropDownLabel,"value":grades[i],"gradeId":classDefnMap[grades[i]].gradeId,"classId":grades[i]});	
											}


											//gradeArr.push({"label":dropDownLabel,"value":grades[i]});	
										}catch(e){
										}
									}
								}
							}

							if(gradeArr && gradeArr.length > 0){
								for(var i=0; i< gradeArr.length; i ++){
									if(gradeArr[i].value == (me.preferredGrade)){ 
										console.log("selectedindex::"+i);
										preselectIndex = i;
									}
								}

							}


							me.selectedGradeOption = gradeArr[preselectIndex];
							me.setState({gradeArr:gradeArr});
							me.getProductList();
						}


						this.getClassNames(callBack);

					}
					getClassNames(callBack){
						var me = this;
						var callBackSuccess = function(response){
							me.setState({comboNamesLoaded:true});
							callBack.apply(this,[response]);
						}

						var callBackFailure = function(error){
							me.showAlert(me.rb("503.title"),me.rb("503.msg"));
						}

						new HmAjax(this.getUrlFor("DASH_COMBO_DATA")).get(callBackSuccess,callBackFailure);	
					}
					gradeDropdownChange(selectedOption){
						this.selectedGradeOption = selectedOption;	
						this.getProductList();
					}
					productDropdownChange(selectedOption){
						this.selectedProductOption = selectedOption;
						this.getTopics();
					}
					getTopics(){
						this.setState({overallPerformanceLoaded:false,recentTopicLoaded:false,grade:this.rb("dash.not_available"),pointsEarned:0,selectedProduct:this.selectedProductOption.value});
						
						let classIdToLoadTopic = (this.selectedGradeOption && this.selectedGradeOption.gradeId) ? this.selectedGradeOption.gradeId : this.selectedGradeOption.value;
						
						// Store request Level to persist across page reloads
                    	localStorage.setItem('storedClassLevel', classIdToLoadTopic);

						this.loadOverallPerformance(this.selectedProductOption.value, classIdToLoadTopic);
						this.loadRecentTopic(this.selectedProductOption.value, classIdToLoadTopic);
					
						try{
							var accessMap = this.getUser().getAccessMap();
							this.noLessonMode = (accessMap[this.selectedProductOption.value] === "PLP|TEST|TAKE");
						}catch(e){}

						try{
							this.gradeStore = {
								"grd":this.selectedGradeOption.value,
								"prod":this.selectedProductOption.value
							}
							this.setAttribute(this.dashboardDropDownKey,JSON.stringify(this.gradeStore));
						}catch(e){}
						
						try{
							var trackObj = {
								"grade_id": this.selectedGradeOption.value,
								"product_type": this.selectedProductOption.value,
								"source":this.getTracker().enums.selectedProductSource.dashboard
							}			
					
							this.initiateTrack("product_selected",trackObj);
						}catch(e){}
					}

					loadRecentTopic(accessId, level){
						var me = this;
						var callBackSuccess = function(response){
							if(typeof response.data === "object" && Object.keys(response.data).length > 0){
								var recentTestData = response.data;
								me.setState({recentTopicLoaded: true,recentTestData:recentTestData});
							}else{
								me.setState({recentTopicLoaded: true,recentTestData:{}});
							}
						}

						var callBackFailure = function(error){
							me.showAlert(me.rb("503.title"),me.rb("503.msg"));
						}

						if(accessId !== undefined && level !== undefined && accessId !== null && level !== null){
							new HmAjax(this.getUrlFor("DASH_RECENT_TEST")+"?access="+accessId+"&level="+level).get(callBackSuccess,callBackFailure);		
						}
					}

					calculateTopicCompletedCount(){
						this.completedTopicCount ++; 
					}		

					resetCount(){
                        this.completedTopicCount = 0;
                    }

					loadOverallPerformance(accessId, level){
						var me = this;

						if(!this.topicListRequestAllowed){
                            return;
                        }

						this.completedTopicCount = 0;
						topicList = new Array();
						var callBackSuccess = function(response){
							me.topicListRequestAllowed = true;
							topicList = new Array();
							if(typeof response.data === "object" && Object.keys(response.data).length > 0){
								me.setState({overallPerformanceLoaded:true});
								me.topicDescMap = response.data.topicDescMap;
								me.topicTestMap = response.data.topicTestMap || response.data.topicLessonMap;
								me.gradeDefns = response.data.gradeDefns;
								me.topicGradeDtls = response.data.topicGradeDtls;

							
							try{
								me.calculateGradeForTopics(me.topicTestMap);
							}catch(e){
								console.error(e);
							}

							me.resetCount();
							if(me.isLessonOnlyProduct(me.state.selectedProduct)){
								for(var i in me.topicTestMap){	
									if(me.topicTestMap[i].status && me.topicTestMap[i].status.toLowerCase() === "completed"){
										me.calculateTopicCompletedCount();
									}
									topicList.push({"label":me.topicTestMap[i].topicName,"value":me.topicTestMap[i].topicId});
								}
							}else{
								for(var i in me.topicDescMap){
									if(me.topicTestMap[i].status && me.topicTestMap[i].status.toLowerCase() === "completed"){
										me.calculateTopicCompletedCount();
									}
									//console.log(me.topicDescMap[i]);
									topicList.push({"label":me.topicTestMap[i].topicName,"value":me.topicTestMap[i].topicId});
								}
							}
							console.log("topicList::::",topicList);
							me.defaultOption = topicList[0];
							me.setState({feedbackText: me.topicTestMap[me.defaultOption.value].feedback || "", grade: me.topicTestMap[me.defaultOption.value].grade || me.rb("dash.not_available"), selectedTopic:me.topicTestMap[me.defaultOption.value],selectedSubTopic:null,pointsEarned:(me.topicTestMap && me.topicTestMap[me.defaultOption.value] && me.topicTestMap[me.defaultOption.value].userPoints && !isNaN(me.topicTestMap[me.defaultOption.value].userPoints)) ? me.topicTestMap[me.defaultOption.value].userPoints : 0});
							//me.setState({selectedTopic:me.topicTestMap[defaultOption.value]}); // using same setState
							//me.populateSubTopics();		
							
						}else{
							
						}
					}

					var callBackFailure = function(error){
						me.topicListRequestAllowed = true;
						me.showAlert(me.rb("503.title"),me.rb("503.msg"));
					}

					if(this.topicListRequestAllowed && accessId !== undefined && level !== undefined && accessId !== null && level !== null){
                        new HmAjax(this.getUrlFor("DASH_OVERALL_PERFORMANCE")+"?access="+accessId+"&level="+level).get(callBackSuccess,callBackFailure);        
                        me.topicListRequestAllowed = false;
                    }
				}

				piechartFn(value,total) {
					if(total>0){
						const piedata = [value,(total-value)]; //how many partitions you want
						const piecolors = ["#FFAA00", "#d1d3d4"]; //partiation color
						const pieindata = [value, "/", total];  //inside data of svg
						//console.log(piedata + " " + piecolors+" "+pieindata);

						return (
							<div className="piechart">
							<PiechartComp
							data={piedata}
							colors={piecolors}
							txtval={pieindata}/>
							</div>
							)
					}
					
				}
				hideLoginModal(){
					this.setState({"ModalShow":false});
				}
				triggerPreviousAttempts(previousAttemptsArray){
					console.log("lala :: ",previousAttemptsArray);
					this.attemptBoundry = 3;
					$(".attemptsBodyContent").css("padding-right","1rem");
					this.showPreviousAttempts(previousAttemptsArray);
				}
				showPreviousAttempts(previousAttemptsArray){
					this.setState({"ModalShow":true,"ModalContent":this.getPreviousAttempts(previousAttemptsArray)});
				}
				showMoreAttempt(){
					this.attemptBoundry = this.attemptsArr.length;
					this.showPreviousAttempts(this.attemptsArr);
					$(".attemptsBodyContent").css("padding-right","0rem");
				}
				showLessAttempt(){
					this.attemptBoundry = 3;
					this.showPreviousAttempts(this.attemptsArr);
					$(".attemptsBodyContent").css("padding-right","1rem");
				}
				getPreviousAttempts(previousAttemptsArray){
					this.attemptsArr = previousAttemptsArray;
					var customAttemptsArr = [];
					if(this.attemptsArr.length>this.attemptBoundry){
						for(var i=0;i<this.attemptBoundry;i++){
							customAttemptsArr.push(this.attemptsArr[i]);
						}
					}else{
						customAttemptsArr = this.attemptsArr;
					}
					let me = this;
					return(
						<div className="attemptsBodyContent">
							<div className="attemptsContainer">
							{customAttemptsArr.map((attempts, index) => {
								return (
										<div className="attemptInfoContainer" key={index}>
											<div className="clearfix attemptInfoTitle">
												<div className="float-left">
													{this.rb("dash.attempt")} #{customAttemptsArr[index].diagnostic.version}
												</div>
												<div className="float-right">
													{this.rb("dash.archive.submitted_on")}: <Moment unix format="DD MMM YYYY  hh:mm:ss A">{me.getTimeUtil().setServerTime((customAttemptsArr[index].customized ? customAttemptsArr[index].customized.endDate : customAttemptsArr[index].diagnostic.endDate)+"").getServerTime()}</Moment>
												</div>
											</div>
											<div className="row col-12 nopadding attemptInfoBody">
												<div className="col-4 row clearfix nopadding rightBorder flexcenter">
													<div className="float-left rightPadding">
														<img className="attemptsGradeEarnedIcon" src={gradeEarnedIcon} />
													</div>
													<div className="float-left">
														<div className="headerTxt clearfix">
															<div>Grade Earned</div>
															<div className="text-center reward rewardsmall c">{customAttemptsArr[index].customized ? customAttemptsArr[index].customized.grade : customAttemptsArr[index].diagnostic.grade}</div>
														</div>
													</div>
												</div>
												<div className="col-4 row clearfix nopadding rightBorder flexcenter">
													<div className="float-left rightPadding">
														<img className="attemptsPointsEarnedSmall" src={pointsEarnedSmall} />
													</div>
													<div className="float-left">
														<div className="headerTxt clearfix">
															<div>Points Earned</div>
															<div className="text-center yellowColor smallPoints">{customAttemptsArr[index].customized ? customAttemptsArr[index].customized.userPoints : customAttemptsArr[index].diagnostic.userPoints}</div>
														</div>
													</div>
												</div>
												<div className="col-4 row clearfix nopadding flexcenter">
													<div className="float-left rightPadding previousreporticon">
														<a href={"/scorecard/"+customAttemptsArr[index].diagnostic.testId+"/"+customAttemptsArr[index].diagnostic.version} >											
															<img className="reportProficienyIcon rightPadding" src={reportProficienyIcon} />
														</a>
													</div>
													{(()=>{
														if(customAttemptsArr[index].customized){
															return(
																<div className="float-left">
																	<a href={"/scorecard/"+customAttemptsArr[index].customized.testId+"/"+customAttemptsArr[index].customized.version} >
																		<img className="reportPracticeIcon" src={reportPracticeIcon} />
																	</a>
																</div>
															)
														}
													})()}
													
												</div>
											</div>
										</div>
								);
							})}	
							</div>
							{( () => {
								if(this.attemptsArr.length > 3 && this.attemptBoundry == 3){
									return(
										<div className="text-right showmore" onClick={this.showMoreAttempt.bind(this,this.attemptsArr)}>
											{this.rb("dash.showmore")}
											<i className="material-icons">keyboard_arrow_down</i>
										</div>
									);
								}else{
									return(
										<div className="text-right showmore showless" onClick={this.showLessAttempt}>
											{this.rb("dash.showless")}
											<i className="material-icons">keyboard_arrow_up</i>
										</div>
									);
								}
							})()}
						</div>
					);
				}
				render() {
					if(this.state.comboNamesLoaded){
						return super.render(
							<div className="DashboardComponent">
							
							<div className="dropdownContainer">
							<Dropdown className="dropdowns hidden" options={this.state.gradeArr} onChange={this.gradeDropdownChange.bind(this)} value={this.selectedGradeOption} placeholder="Select an option" />
							<Dropdown className="dropdowns" options={this.state.productArr} onChange={this.productDropdownChange.bind(this)} value={this.selectedProductOption} placeholder="Select an option" />
							</div>
							<div className="col-12 nopadding">
							<div className="no-margin-bottom dashboardtitle">{this.rb("title.dashboard")}</div>			
							</div>
							<div className="row dashboardContentContainer">
							<div className="col-lg-6 widgets noleftpadding">
							<div className="card">

							<div className="card-header d-flex align-items-center">
							<div>{this.getTopicsCompletedTitle()}</div>
							</div>
							<div className="card-body">
							{this.getTopicsCompletedContent()}
							</div>
							</div>
							</div>
							<div className="col-lg-6 widgets noleftpadding">
							<div className="card">

							<div className="card-header d-flex align-items-center">
							<div>{this.getRecentAttemptTitle()}</div>
							</div>
							<div className="card-body recentAttemptBody">
							{this.getRecentAttemptedTopicContent()}
							</div>
							</div>
							</div>
							<div className="col-lg-12 widgets noleftpadding">
							<div className="card">

							<div className="card-header d-flex align-items-center">
							<div>{this.getOverallTitle()}</div>
							</div>
							<div className="card-body">
							
							{this.getOverallPerformanceContent()}
							</div>
							</div>
							</div>            
							</div>
							
							<div>							
								<TestTakingModalComponent visible={this.state.ModalShow} dialogClassName="attemptsModalDialog">
									<div className="attemptsHeader">	
										<div className="text-center attemptsheadertext">
											{this.rb("dash.previousattempts")}
										</div>
										<div className="close attemptsClose" onClick={this.hideLoginModal} aria-label="Close">
								          <span aria-hidden="true"><i className="material-icons">close</i></span>
								        </div>
									</div>
									<div className="modal-body attemptsModalBody">
										{this.state.ModalContent}
									</div>							
								</TestTakingModalComponent>
							</div>
							
							</div>
							
							);
					}else if(this.state.noProducts){
						return super.render(
							<div className="messageView expiredView text-center">
								<span className="expiredlock"><i class="material-icons">lock</i></span>
								<h3>{this.rb("register.noproducts.msg")}</h3>
								<h3>{this.rb("register.noproducts.msg2")}</h3>
								<h3>{ReactHtmlParser(this.rb("register.noproducts.msg3"))}</h3>
							</div>
							);	
						
					}
					else{
						return super.render();
					}

				}
			}

			export default Dashboard;
 



// WEBPACK FOOTER //
// ./src/views/dashboard/Dashboard.js